<template>
  <div>
    <div class="h footerIOS" style="min-height: 0.54rem"></div>
    <ul class="footer footerIOS">
      <li
        :class="{
          footers:
            (homeIcon &&
              ((footerIndex == 0 && footerIndex + 2 == index) ||
                (footerIndex > 0 && footerIndex <= 2 && footerIndex - 1 == index) ||
                (footerIndex > 2 && footerIndex == index))) ||
            (!homeIcon && footerIndex == index)
        }"
        :key="index"
        @click="footerClick(index)"
        v-for="(item, index) of listData"
      >
        <div :class="{ homeIconTags: homeIcon && index == 2 }" class="tagsImg">
          <i v-if="index == 3 && cartnum > 0"></i>
          <img
            :class="{ homeIcon: homeIcon && index == 2 }"
            :src="item.changeIcon"
            v-if="
              (homeIcon &&
                ((footerIndex == 0 && footerIndex + 2 == index) ||
                  (footerIndex > 0 && footerIndex <= 2 && footerIndex - 1 == index) ||
                  (footerIndex > 2 && footerIndex == index))) ||
              (!homeIcon && footerIndex == index)
            "
          />
          <img :class="{ homeIcon: homeIcon && index == 2 }" :src="item.icon" v-else />
        </div>
        <p>{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footerComp',
  data() {
    return {
      listData: [],
      tagValue: 99,
      homeIcon: ''
    }
  },
  props: {
    footerIndex: {
      type: Number,
      default: 0
    },
    cartnum: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // // 挂载完成后，判断浏览器是否支持popstate
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    this.hasNewMsg()
  },
  destroyed() {
    // window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    // goBack() {
    //   // 个人中心进入返回上一级，支付后进入返回首页
    //   if (!this.$route.query.route) {
    //     this.$router.replace({path: '/'})
    //   } else {
    //     history.go(-1);
    //   }
    // },
    async hasNewMsg() {
      let { data } = await this.$customRequestAjax(this.$ajax.hasNewMsg_URL)
      this.homeIcon = data.data.homeicon
      if (this.homeIcon) {
        this.listData = [
          {
            icon: require('../../assets/images/classification.png'),
            changeIcon: require('../../assets/images/classification1.png'),
            title: '分类'
          },
          {
            icon: require('../../assets/images/community.png'),
            changeIcon: require('../../assets/images/community1.png'),
            title: '社区'
          },
          {
            icon: this.homeIcon,
            changeIcon: this.homeIcon,
            title: ''
          },
          {
            icon: require('../../assets/images/goshopping.png'),
            changeIcon: require('../../assets/images/goshopping1.png'),
            title: '购物车'
          },
          {
            icon: require('../../assets/images/my.png'),
            changeIcon: require('../../assets/images/my1.png'),
            title: '我的'
          }
        ]
      } else {
        this.listData = [
          {
            icon: require('../../assets/images/home.png'),
            changeIcon: require('../../assets/images/home1.png'),
            title: '首页'
          },
          {
            icon: require('../../assets/images/classification.png'),
            changeIcon: require('../../assets/images/classification1.png'),
            title: '分类'
          },
          {
            icon: require('../../assets/images/community.png'),
            changeIcon: require('../../assets/images/community1.png'),
            title: '社区'
          },
          {
            icon: require('../../assets/images/goshopping.png'),
            changeIcon: require('../../assets/images/goshopping1.png'),
            title: '购物车'
          },
          {
            icon: require('../../assets/images/my.png'),
            changeIcon: require('../../assets/images/my1.png'),
            title: '我的'
          }
        ]
      }
    },
    footerClick: function (idx) {
      window.scrollTo(0, 0)
      if (this.homeIcon) {
        switch (idx) {
          case 0:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'classbutton'
              }
            })
            this.$router.push('/classification')
            break
          case 1:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'communitybutton'
              }
            })
            this.$store.commit('COMMUNITY_TAB', 1)
            this.$router.push('/community')
            break
          case 2:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'indexbutton'
              }
            })
            this.$router.push('/')
            break
          case 3:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'shopcartbutton'
              }
            })
            this.$router.push('/cart')
            break
          case 4:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'mybutton'
              }
            })
            // window.location.href = '/percen?t=' + new Date().getTime()
            this.$router.push({ path: '/percen' })
            break
        }
      } else {
        switch (idx) {
          case 0:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'indexbutton'
              }
            })
            this.$router.push('/')
            break
          case 1:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'classbutton'
              }
            })
            this.$router.push('/classification')
            break
          case 2:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'communitybutton'
              }
            })
            this.$store.commit('COMMUNITY_TAB', 1)
            this.$router.push('/community')
            break
          case 3:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'shopcartbutton'
              }
            })
            this.$router.push('/cart')
            break
          case 4:
            this.$clickburiedPoint({
              data: {
                buttonCode: 'mybutton'
              }
            })
            // window.location.href = '/percen?t=' + new Date().getTime()
            this.$router.push({ path: '/percen' })
            break
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  background: #fff;
  padding: 0.08rem 0.35rem 0;
  display: flex;
  display: -moz-flex;
  display: -o-flex;
  display: -ms-flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -o-justify-content: space-between;
  -ms-justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2001;
  box-shadow: 0px -1px 10px 0px rgba(236, 236, 236, 0.5);
  li {
    padding-bottom: 0.08rem;
    .tagsImg {
      width: 0.21rem;
      margin: 0 auto;
      position: relative;
      i {
        display: block;
        font-style: normal;
        position: absolute;
        min-width: 0.07rem;
        min-height: 0.07rem;
        background: rgba(252, 3, 36, 1);
        font-size: 0.1rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.15rem;
        border-radius: 50%;
        right: -40%;
        top: -15%;
      }
      img {
        width: 0.21rem;
        height: 0.21rem;
        margin-bottom: 0.01rem;
      }
      &.homeIconTags {
        width: 0.55rem;
      }
      .homeIcon {
        width: 0.55rem;
        height: 0.55rem;
        position: absolute;
        top: -0.2rem;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    img {
      width: 0.21rem;
      height: 0.21rem;
      margin: 0 auto;
      margin-bottom: 0.04rem;
    }
    p {
      font-size: 0.1rem;
      font-weight: 500;
      color: #333333;
    }
    &.footers {
      p {
        color: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footerComp.vue